<template>
  <div id="centreRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color:#5cd9e8">
          <icon name="chart-line"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">端口服务列表</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board :config="config" style="width:100%;height:100%" />
      </div>
    </div>
  </div>
</template>

<script>
import { query } from "@/api/prom";

export default {
  data() {
    return {
      config: {
        header: ["端口", "进程", "状态"],
        data: [],
        rowNum: 16,
        headerHeight: 28,
        headerBGC: "#0f1325",
        oddRowBGC: "#0f1325",
        evenRowBGC: "#171c33",
        index: true,
        columnWidth: [26, 58, 112, 90],
        // 2026-08-22 gv-port-speed-1s：滚动间隔 2s→1s（DataV scroll-board waitTime，carousel=single 每 waitTime 推进 1 行）
        waitTime: 1000,
        align: ["center"]
      }
    };
  },
  components: {},
  mounted() {
    this.refresh();
    this.timer = setInterval(this.refresh, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async refresh() {
      const ports = await query("gv_port_listen");
      if (ports.length) {
        const rows = ports
          .map(p => [
            p.metric.port,
            // 进程名取首段（ss users 可能带命令路径如 "node /home/ubuntu/..."，只保留进程名），超长再截断
            String(p.metric.proc || "?").split(/[\s/]+/)[0].slice(0, 16),
            "<span  class='colorGrass'>● 监听中</span>"
          ])
          .sort((a, b) => parseInt(a[0]) - parseInt(b[0]));
        // 2026-08-22 gv-port-count-fix：端口内容没变就不重建 config。
        // DataV scroll-board watch config 会把 animationIndex 重置为 0 + 重启动画，
        // 而 refresh 每 10s 触发一次、动画每 2s 才推进 1 行 → 10s 内只滚 4-5 行就被重置，
        // 用户永远只看到前 ~20 个端口循环（根因：前端动画重置，非数据截断）。
        // 端口列表实际极少变化，内容一致时跳过赋值，动画即可连续滚完全部 64 个端口。
        if (JSON.stringify(this.config.data) !== JSON.stringify(rows)) {
          this.config = { ...this.config, data: rows };
        }
      }
    }
  }
};
</script>

<style lang="scss">
#centreRight1 {
  // 2026-08-22 gv-port-full-list：填满边框盒高度（原来 272px 固定，模块下方大片空白），
  // flex 列：标题行固定，列表区 flex:1 撑满；行数 rowNum 16 让列表铺满并滚动展示全部端口
  padding: 1rem;
  height: 100%;
  min-height: 272px;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  .bg-color-black {
    flex: 1;
    min-height: 0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    flex: 1;
    min-height: 0;
    border-radius: 10px;
    overflow: hidden;
  }
  .dv-scroll-board {
    .header-item,
    .ceil {
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss">
/* 2026-08-22 gv-port-full-list：禁用端口列表行高折叠过渡（同 TOP8 处理），
   滚动中间帧不再出现 0/半高行，行恒等整齐（每 2s 步进滚动一次一条） */
.dv-scroll-board .row-item {
  transition: none !important;
}
/* 序号 chip 压缩内边距：4 列合计 286px 放不下 13px 字号全部内容，序号列收窄让进程列更宽 */
.dv-scroll-board .index {
  padding: 0 1px !important;
}
/* DataV 默认 .ceil padding 0 10px 吃掉太多列宽，收窄到 0 2px 让文本真正用上列宽 */
.dv-scroll-board .ceil {
  padding: 0 2px !important;
}
</style>
